import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";
import { RecommendAgent } from "@app/core/models/recommend-agent";
import { ResultStatus } from "@app/core/models/result-status";
import { AgentSkillService } from "@app/core/services/agent-skill.service";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { HelperService } from "@app/core/services/helper.service";
import { RecommendAgentService } from "@app/core/services/recommend-agent.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-agent-recommend-skills",
  templateUrl: "./agent-recommend-skills.component.html",
  styleUrls: ["./agent-recommend-skills.component.scss"],
})
export class AgentRecommendSkillsComponent implements OnInit {
  @Input() agent: any;
  @Input() showRecommendAndSkillManage: boolean;
  @Input() showRecommendAgent: boolean;
  @Output() updateParentView = new EventEmitter();
  activeRecommendSkillTabId = 0;
  public showRecommendCounterLimit = 0;
  public showRecommendCounter = 0;
  public isShowLessRecommend = false;
  displayRecommendationAndSkils = true;
  displayRecommendAgent = false;

  agentRecommendForm: FormGroup;
  sendRecommendAgentModel: RecommendAgent;
  isVisible = false;
  presubmitted = false;
  recommendation: any;
  relationText = "";
  recommendationID: any;
  agentID = 0;
  submitted = false;
  howdoyouknowList = [];

  noSkillsVisible = false;

  agentFirstName = "";
  agentLastName = "";
  agentEndorsedSkillList = [];

  constructor(
    private formBuilder: FormBuilder,
    private recommendAgentService: RecommendAgentService,
    private authService: AuthenticationService,
    private helperService: HelperService,
    private sanit: DomSanitizer,
    private agentSkillService: AgentSkillService,
    private toaster: ToastrService
  ) {
    this.showRecommendCounterLimit = 2;
    this.showRecommendCounter = this.showRecommendCounterLimit;
  }

  ngOnInit() {
    this.agentID = this.agent.ID;
    this.getAgentEndorseSkills();

    this.noSkillsVisible = this.agentID == this.authService.getUserInformation()["ID"];
  }

  changeTab(event) {
    if (event.id === "skill") {
      this.activeRecommendSkillTabId = 1;
    } else {
      this.activeRecommendSkillTabId = 0;
    }
  }

  bindAgentRecommendationForm() {
    this.setAgentRecommendForm();
    this.bindhowdoyouknowListList();

    this.recommendation = {
      firstName: this.agent.FirstName,
      lastName: this.agent.LastName,
      imgUrl: this.agent.ImageUrl,
    };
  }

  getRecommendationById(id) {
    this.recommendAgentService.getRecommendationById(id).subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.agentRecommendForm.controls["howDoYouKnow"].setValue(
          result.Data.HowDoYouKnowId
        );
        this.recommendation = {
          firstName: result.Data.ReceiverName,
          lastName: "",
          imgUrl: result.Data.ReceiverImageUrl,
        };
        this.nextView();
      }
    });
  }

  setAgentRecommendForm() {
    this.agentRecommendForm = this.formBuilder.group({
      howDoYouKnow: new FormControl("", [Validators.required]),
      recommendation: new FormControl("", [Validators.required]),
    });
  }

  nextView() {
    this.presubmitted = true;
    if (
      !this.helperService.isUndefinedOrNullOrEmpty(
        this.agentRecommendForm.controls["howDoYouKnow"].value
      )
    ) {
      this.isVisible = true;
      this.relationText = this.howdoyouknowList.find(
        (x) =>
          x.Value === this.agentRecommendForm.controls["howDoYouKnow"].value
      ).Text;
    }
  }

  sendRecommendation() {
    this.submitted = true;
    if (this.agentRecommendForm.invalid) {
      return false;
    } else {
      this.sendRecommendAgentModel = new RecommendAgent();
      this.sendRecommendAgentModel.Text = this.agentRecommendForm.controls[
        "recommendation"
      ].value;
      this.sendRecommendAgentModel.HowDoYouKnowId = this.agentRecommendForm.controls[
        "howDoYouKnow"
      ].value;
      this.sendRecommendAgentModel.SenderId = +this.authService.getUserInformation()["ID"];
      this.sendRecommendAgentModel.StatusId = 0;
      this.sendRecommendAgentModel.IsDeleted = false;
      this.sendRecommendAgentModel.IsVisible = false;
      this.sendRecommendAgentModel.ReceiverId = this.agentID;

      if (!this.helperService.isUndefinedOrNullOrEmpty(this.recommendationID)) {
        this.sendRecommendAgentModel.ID = this.recommendationID;
        this.recommendAgentService
          .reviseRecommendation(this.sendRecommendAgentModel)
          .subscribe((result) => {
            if (result.Status === ResultStatus.Success) {
              this.reset();
            }
          });
      } else {
        this.recommendAgentService
          .sendRecommendation(this.sendRecommendAgentModel)
          .subscribe((result) => {
            if (result.Status === ResultStatus.Success) {
              this.reset();
            }
          });
      }
    }
  }

  reset() {
    this.presubmitted = false;
    this.submitted = false;
    this.agentRecommendForm.reset('');
    this.agentRecommendForm.setErrors(null);
    this.hideView();
  }

  bindhowdoyouknowListList() {
    this.recommendAgentService.getHowDoYouKnowList().subscribe((result) => {
      if (result.Status === ResultStatus.Success) {
        this.howdoyouknowList = result.Data;
      }
    });
  }

  onShowMoreLessRecommendClick() {
    this.isShowLessRecommend = !this.isShowLessRecommend;
    if (this.isShowLessRecommend) {
      this.showRecommendCounter = this.agent.AgentRecommendation.length;
    } else {
      this.showRecommendCounter = this.showRecommendCounterLimit;
    }
  }

  getImgsSanitized(imageURL: any) {
    if (imageURL) {
      return this.sanit.bypassSecurityTrustStyle(
        "url(" + imageURL + "), url(/assets/images/user-icon.png)"
      );
    } else {
      return this.sanit.bypassSecurityTrustStyle(
        "url(/assets/images/user-icon.png)"
      );
    }
  }

  recommendAgent() {
    this.displayRecommendationAndSkils = false;
    this.displayRecommendAgent = true;
    this.bindAgentRecommendationForm();
  }

  hideRecommendView() {
    this.hideView();
  }

  hideEndorsedSkill() {
    this.hideView();
  }

  hideView() {
    this.displayRecommendationAndSkils = true;
    this.displayRecommendAgent = false;
    this.activeRecommendSkillTabId = 0;
    this.isVisible = false;
    this.updateParentView.emit();
  }

  getAgentEndorseSkills() {
    this.agentSkillService.getAgentEndorseSkills(this.agentID).subscribe(
      (result) => {
        if (result.Status === ResultStatus.Success) {
          this.agentEndorsedSkillList = result.Data;
        } else {
          this.toaster.error("Something went wrong");
        }
      },
      (error) => {
        this.toaster.error("Something went wrong");
      }
    );
  }

  manageEndorsedSkill(SkillId, endorseAgentSkillId, isEndorsed) {
    if (isEndorsed) {
      this.deleteEndorsedSkill(endorseAgentSkillId);
    } else {
      this.endorseAgentSkill(SkillId);
    }
  }

  endorseAgentSkill(skillId) {
    const postData = {
      AgentId: this.agentID,
      SkillId: skillId,
      EndorseBy: this.authService.getUserInformation()["ID"]
    };
    this.agentSkillService.postAgentEndorseSkills(postData).subscribe(
      (result) => {
        if (result.Status === ResultStatus.Success) {
          this.getAgentEndorseSkills();
        } else {
          this.toaster.error("Something went wrong");
        }
      },
      (error) => {
        this.toaster.error("Something went wrong");
      }
    );
  }

  deleteEndorsedSkill(endorsedSkillId) {
    this.agentSkillService.deleteAgentEndorsedSkill(endorsedSkillId).subscribe(
      (result) => {
        if (result.Status === ResultStatus.Success) {
          this.getAgentEndorseSkills();
        } else {
          this.toaster.error("Something went wrong");
        }
      },
      (error) => {
        this.toaster.error("Something went wrong");
      }
    );
  }
}
